import ActionTypes from '../../actionTypes'
const { GET_ALL_DATA_FAIL, GET_ALL_DATA_SUCCESS } = ActionTypes.REPORTS.FLEET_STATUS_HISTORY

const initialState = {
  snapshots: [],
  dataCount: 0,
}

const fleetStatusHistoryReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case GET_ALL_DATA_SUCCESS:
      return {
        ...state,
        snapshots: payload.rows,
        dataCount: payload.count,
      }
    case GET_ALL_DATA_FAIL:
      return {
        ...state,
        snapshots: [],
        dataCount: 0,
      }
    default:
      return state
  }
}

export default fleetStatusHistoryReducer
